import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, Box, Card, CardContent, Divider, FormHelperText, Grid, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Formik } from "formik";
import { useParams } from "react-router-dom";
import * as Yup from 'yup';
import { useGetAllRolesQuery } from "store/slices/apis/rolesSlice";
import CustomButton from "components/Button";
import SaveIcon from '@mui/icons-material/Save';
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import { useAssignPermissionMutation, useLazyGetCheckRolePermissionQuery } from "store/slices/apis/userRoleApiSlice";
import {
    ACTION_TRACKER_ACCESS, ACTION_TRACKER_COMMENT, ACTION_TRACKER_CREATE, ACTION_TRACKER_DATA_ACCESS, ACTION_TRACKER_DELETE, ACTION_TRACKER_EDIT, ACTION_TRACKER_VIEW,
    ACTIVITY_WISE_ACCESS,
    BASELINE_SCHEDULE_ACCESS, BASELINE_SCHEDULE_APPROVED, BASELINE_SCHEDULE_CREATE,
    BASELINE_SCHEDULE_INPROGRESS,
    CAPEX_ACCESS,
    CAPEX_CREATE,
    CAPEX_MENU_ACCESS,
    CHANGE_ACCESS,
    CHANGE_COMMENT,
    CHANGE_CREATE,
    CHANGE_DELETE,
    CHANGE_EDIT,
    CHANGE_VIEW,
    CLAIM_ACCESS,
    CLAIM_COMMENT,
    CLAIM_CREATE,
    CLAIM_DELETE,
    CLAIM_EDIT,
    CLAIM_VIEW,
    COMMERCIAL_DATA_ACCESS,
    COMMITTED_COST_ACCESS,
    COMPLIANCE_ACCESS,
    COMPLIANCE_COMMENT,
    COMPLIANCE_CREATE,
    COMPLIANCE_DATA_ACCESS,
    COMPLIANCE_DELETE,
    COMPLIANCE_EDIT,
    COMPLIANCE_VIEW,
    CONTRACT_MANAGEMENT_ACCESS,
    COST_MANAGEMENT_ACCESS,
    COST_TRACKER_ACCESS,
    COST_UPDATE_ACCESS,
    DEALS_TRACKER_ACCESS,
    DEALS_TRACKER_CREATE,
    DEALS_TRACKER_DELETE,
    DEALS_TRACKER_EDIT,
    DEALS_TRACKER_VIEW,
    DESIGN_ENGINEERING_DATA_ACCESS,
    DMS_ACCESS,
    EHS_FINDING_DATA_ACCESS,
    EHS_FINDING_TRACKER_ACCESS,
    EHS_FINDING_TRACKER_CREATE,
    EHS_FINDING_TRACKER_EDIT,
    EHS_FINDING_TRACKER_VIEW,
    ENGINEERING_ACCESS,
    ENGINEERING_COMMENT,
    ENGINEERING_CREATE,
    ENGINEERING_DASHBOARD_ACCESS,
    ENGINEERING_DELETE,
    ENGINEERING_EDIT,
    ENGINEERING_VIEW,
    ERP_DATA_ACCESS,
    ERP_DATA_CREATE,
    ERP_DATA_VIEW,
    FINANCIAL_BG_ACCESS,
    FINANCIAL_BG_CREATE,
    FINANCIAL_BG_EDIT,
    FINANCIAL_BG_VIEW,
    HSE_ACCESS,
    HSE_CREATE,
    HSE_DASHBOARD_ACCESS,
    HSE_DATA_ACCESS,
    IMPLEMENTATION_SCHEDULE_ACCESS, IMPLEMENTATION_SCHEDULE_APPROVED, IMPLEMENTATION_SCHEDULE_CREATE,
    IMPLEMENTATION_SCHEDULE_INPROGRESS,
    INCIDENT_ACCESS,
    INCIDENT_CREATE,
    INCIDENT_EDIT,
    INCIDENT_VIEW,
    INITIATE_WORKFLOW_ACCESS,
    INSURANCE_DATA_ACCESS,
    INVOICE_TRACKER_ACCESS,
    INVOICE_TRACKER_CREATE,
    INVOICE_TRACKER_EDIT,
    INVOICE_TRACKER_VIEW,
    LEADS_DATA_ACCESS,
    LEADS_TRACKER_ACCESS,
    LEADS_TRACKER_CREATE,
    LEADS_TRACKER_DELETE,
    LEADS_TRACKER_EDIT,
    LEADS_TRACKER_VIEW,
    LEASE_DASHBOARD_ACCESS,
    LEGAL_COMPLIANCE_DATA_ACCESS,
    LEGAL_TRACKER_ACCESS,
    LEGAL_TRACKER_CREATE,
    LEGAL_TRACKER_EDIT,
    LEGAL_TRACKER_VIEW,
    MACHINERY_ACCESS,
    MACHINERY_COMMENT,
    MACHINERY_CREATE,
    MACHINERY_DELETE,
    MACHINERY_EDIT,
    MACHINERY_VIEW,
    MANPOWER_ACCESS,
    MANPOWER_COMMENT,
    MANPOWER_CREATE,
    MANPOWER_DELETE,
    MANPOWER_EDIT,
    MANPOWER_VIEW,
    MASTER_DATA_ACCESS,
    MASTER_DEVELOPMENT_SCHEDULE_ACCESS, MASTER_DEVELOPMENT_SCHEDULE_APPROVED, MASTER_DEVELOPMENT_SCHEDULE_CREATE,
    MASTER_DEVELOPMENT_SCHEDULE_INPROGRESS,
    MATERIAL_ACCESS,
    MATERIAL_COMMENT,
    MATERIAL_CREATE,
    MATERIAL_DELETE,
    MATERIAL_EDIT,
    MATERIAL_VIEW,
    MILESTONE_ACCESS,
    MILESTONE_COMMENT,
    MILESTONE_CREATE,
    MILESTONE_DELETE,
    MILESTONE_EDIT,
    MILESTONE_VIEW,
    MONTHLY_PLAN_ACCESS,
    MONTHLY_PLAN_COMMENT,
    MONTHLY_PLAN_CREATE,
    MONTHLY_PLAN_DELETE,
    MONTHLY_PLAN_EDIT,
    MONTHLY_PLAN_VIEW,
    NCR_LOG_ACCESS,
    NCR_LOG_COMMENT,
    NCR_LOG_CREATE,
    NCR_LOG_DELETE,
    NCR_LOG_EDIT,
    NCR_LOG_VIEW,
    OPERATING_COST_DATA_ACCESS,
    PHYSICAL_PROGRESS_ACCESS,
    PHYSICAL_PROGRESS_COMMENT,
    PHYSICAL_PROGRESS_CREATE,
    PHYSICAL_PROGRESS_DELETE,
    PHYSICAL_PROGRESS_EDIT,
    PHYSICAL_PROGRESS_VIEW,
    PROCUREMENT_ACCESS,
    PROCUREMENT_COMMENT,
    PROCUREMENT_CREATE,
    PROCUREMENT_DASHBOARD_ACCESS,
    PROCUREMENT_DATA_ACCESS,
    PROCUREMENT_DELETE,
    PROCUREMENT_EDIT,
    PROCUREMENT_VIEW,
    PROJECT_SETTING,
    RAIL_DATA_ACCESS,
    REBASELINE_SCHEDULE_ACCESS, REBASELINE_SCHEDULE_APPROVED, REBASELINE_SCHEDULE_CREATE,
    REBASELINE_SCHEDULE_INPROGRESS,
    RECOVERY_SCHEDULE_ACCESS, RECOVERY_SCHEDULE_APPROVED, RECOVERY_SCHEDULE_CREATE,
    RECOVERY_SCHEDULE_INPROGRESS,
    RESOURCE_WISE_ACCESS,
    RISK_ACCESS,
    RISK_COMMENT,
    RISK_CREATE,
    RISK_DASHBOARD_ACCESS,
    RISK_DATA_ACCESS,
    RISK_DELETE,
    RISK_EDIT,
    RISK_VIEW,
    SCHEDULE_DASHBOARD_ACCESS,
    STATUTORY_APPROVAL_ACCESS,
    STATUTORY_APPROVAL_COMMENT,
    STATUTORY_APPROVAL_CREATE,
    STATUTORY_APPROVAL_DATA_ACCESS,
    STATUTORY_APPROVAL_DELETE,
    STATUTORY_APPROVAL_EDIT,
    STATUTORY_APPROVAL_VIEW,
    UPDATE_SCHEDULE_ACCESS, UPDATE_SCHEDULE_ACTUALUPDATE, UPDATE_SCHEDULE_APPROVED, UPDATE_SCHEDULE_CREATE,
    UPDATE_SCHEDULE_INPROGRESS,
    VIEW_SCHEDULE_ACCESS,
    WAREHOUSING_DATA_ACCESS,
    WORKFLOW_ACCESS,
    WORKFLOW_DATA_ACCESS
} from "helpers/permissionConfig";
import { EHS_FINDING_TRACKER_DELETE } from "../../helpers/permissionConfig";

const permissionConfig = [
    {
        label: "Dashboard Access",
        key: "dashboardAccess",
        permissions: [
            { label: "Cost Management", value: COST_MANAGEMENT_ACCESS },
            { label: "Schedule", value: SCHEDULE_DASHBOARD_ACCESS },
            { label: "Engineering", value: ENGINEERING_DASHBOARD_ACCESS },
            { label: "Risk", value: RISK_DASHBOARD_ACCESS },
            { label: "Procurement", value: PROCUREMENT_DASHBOARD_ACCESS },
            { label: "Contract Management", value: CONTRACT_MANAGEMENT_ACCESS },
            { label: "HSE", value: HSE_DASHBOARD_ACCESS },
            { label: "LEASE", value: LEASE_DASHBOARD_ACCESS },
        ]
    },
    {
        label: "Action Tracker",
        key: "actionTracker",
        permissions: [
            { label: "Access", value: ACTION_TRACKER_ACCESS },
            { label: "Create", value: ACTION_TRACKER_CREATE },
            { label: "View", value: ACTION_TRACKER_VIEW },
            { label: "Edit", value: ACTION_TRACKER_EDIT },
            { label: "Delete", value: ACTION_TRACKER_DELETE },
            { label: "Comment", value: ACTION_TRACKER_COMMENT },
        ]
    },
    {
        label: "Risk Tracker",
        key: "riskTracker",
        permissions: [
            { label: "Access", value: RISK_ACCESS },
            { label: "Create", value: RISK_CREATE },
            { label: "View", value: RISK_VIEW },
            { label: "Edit", value: RISK_EDIT },
            { label: "Delete", value: RISK_DELETE },
            { label: "Comment", value: RISK_COMMENT },
        ]
    },
    {
        label: "Compliance Tracker",
        key: "complianceTracker",
        permissions: [
            { label: "Access", value: COMPLIANCE_ACCESS },
            { label: "Create", value: COMPLIANCE_CREATE },
            { label: "View", value: COMPLIANCE_VIEW },
            { label: "Edit", value: COMPLIANCE_EDIT },
            { label: "Delete", value: COMPLIANCE_DELETE },
            { label: "Comment", value: COMPLIANCE_COMMENT },
        ]
    },
    {
        label: "Engineering Tracker",
        key: "engineeringTracker",
        permissions: [
            { label: "Access", value: ENGINEERING_ACCESS },
            { label: "Create", value: ENGINEERING_CREATE },
            { label: "View", value: ENGINEERING_VIEW },
            { label: "Edit", value: ENGINEERING_EDIT },
            { label: "Delete", value: ENGINEERING_DELETE },
            { label: "Comment", value: ENGINEERING_COMMENT },
        ]
    },
    {
        label: "Statutory Approval Tracker",
        key: "statutoryApprovalTracker",
        permissions: [
            { label: "Access", value: STATUTORY_APPROVAL_ACCESS },
            { label: "Create", value: STATUTORY_APPROVAL_CREATE },
            { label: "View", value: STATUTORY_APPROVAL_VIEW },
            { label: "Edit", value: STATUTORY_APPROVAL_EDIT },
            { label: "Delete", value: STATUTORY_APPROVAL_DELETE },
            { label: "Comment", value: STATUTORY_APPROVAL_COMMENT },
        ]
    },
    {
        label: "NCR Log Tracker",
        key: "ncrLogTracker",
        permissions: [
            { label: "Access", value: NCR_LOG_ACCESS },
            { label: "Create", value: NCR_LOG_CREATE },


            { label: "View", value: NCR_LOG_VIEW },
            { label: "Edit", value: NCR_LOG_EDIT },
            { label: "Delete", value: NCR_LOG_DELETE },
            { label: "Comment", value: NCR_LOG_COMMENT },
        ]
    },
    {
        label: "Procurement Tracker",
        key: "procurementTracker",
        permissions: [
            { label: "Access", value: PROCUREMENT_ACCESS },
            { label: "Create", value: PROCUREMENT_CREATE },
            { label: "View", value: PROCUREMENT_VIEW },
            { label: "Edit", value: PROCUREMENT_EDIT },
            { label: "Delete", value: PROCUREMENT_DELETE },
            { label: "Comment", value: PROCUREMENT_COMMENT },
        ]
    },
    {
        label: "Claim Tracker",
        key: "claimTracker",
        permissions: [
            { label: "Access", value: CLAIM_ACCESS },
            { label: "Create", value: CLAIM_CREATE },
            { label: "View", value: CLAIM_VIEW },
            { label: "Edit", value: CLAIM_EDIT },
            { label: "Delete", value: CLAIM_DELETE },
            { label: "Comment", value: CLAIM_COMMENT },
        ]
    },
    // {
    //     label: "Claim Tracker",
    //     key: "claimTracker",
    //     permissions: [
    //         { label: "Access", value: CLAIM_ACCESS },
    //         { label: "Create", value: CLAIM_CREATE },
    //         { label: "View", value: CLAIM_VIEW },
    //         { label: "Edit", value: CLAIM_EDIT },
    //         { label: "Delete", value: CLAIM_DELETE },
    //         { label: "Comment", value: CLAIM_COMMENT },
    //     ]
    // },
    {
        label: "Change Tracker",
        key: "changeTracker",
        permissions: [
            { label: "Access", value: CHANGE_ACCESS },
            { label: "Create", value: CHANGE_CREATE },
            { label: "View", value: CHANGE_VIEW },
            { label: "Edit", value: CHANGE_EDIT },
            { label: "Delete", value: CHANGE_DELETE },
            { label: "Comment", value: CHANGE_COMMENT },
        ]
    },
    {
        label: "Financial BG Tracker",
        key: "financialBgTracker",
        permissions: [
            { label: "Access", value: FINANCIAL_BG_ACCESS },
            { label: "Create", value: FINANCIAL_BG_CREATE },
            { label: "View", value: FINANCIAL_BG_VIEW },
            { label: "Edit", value: FINANCIAL_BG_EDIT },
            // { label: "Delete", value: CHANGE_DELETE },
            // { label: "Comment", value: CHANGE_COMMENT },
        ]
    },
    {
        label: "Invoice Tracker",
        key: "inVoiceTracker",
        permissions: [
            { label: "Access", value: INVOICE_TRACKER_ACCESS },
            { label: "Create", value: INVOICE_TRACKER_CREATE },
            { label: "View", value: INVOICE_TRACKER_VIEW },
            { label: "Edit", value: INVOICE_TRACKER_EDIT }
        ]
    },
    {
        label: "ERP Data Tracker",
        key: "erpDataTracker",
        permissions: [
            { label: "Access", value: ERP_DATA_ACCESS },
            { label: "Create", value: ERP_DATA_CREATE },
            { label: "View", value: ERP_DATA_VIEW }
        ]
    },
    {
        label: "Implementaion Schedule",
        key: "implementaionSchedule",
        permissions: [
            { label: "Access", value: IMPLEMENTATION_SCHEDULE_ACCESS },
            { label: "Create", value: IMPLEMENTATION_SCHEDULE_CREATE },
            { label: "Approved", value: IMPLEMENTATION_SCHEDULE_APPROVED },
            { label: "In Progress", value: IMPLEMENTATION_SCHEDULE_INPROGRESS },
        ]
    },
    {
        label: "Master Development Schedule",
        key: "masterDevelopmentSchedule",
        permissions: [
            { label: "Access", value: MASTER_DEVELOPMENT_SCHEDULE_ACCESS },
            { label: "Create", value: MASTER_DEVELOPMENT_SCHEDULE_CREATE },
            { label: "Approved", value: MASTER_DEVELOPMENT_SCHEDULE_APPROVED },
            { label: "In Progress", value: MASTER_DEVELOPMENT_SCHEDULE_INPROGRESS },
        ]
    },
    {
        label: "Baseline Schedule",
        key: "baseLineSchedule",
        permissions: [
            { label: "Access", value: BASELINE_SCHEDULE_ACCESS },
            { label: "Create", value: BASELINE_SCHEDULE_CREATE },
            { label: "Approved", value: BASELINE_SCHEDULE_APPROVED },
            { label: "In Progress", value: BASELINE_SCHEDULE_INPROGRESS },
        ]
    },
    {
        label: "Recovery Schedule",
        key: "recoverySchedule",
        permissions: [
            { label: "Access", value: RECOVERY_SCHEDULE_ACCESS },
            { label: "Create", value: RECOVERY_SCHEDULE_CREATE },
            { label: "Approved", value: RECOVERY_SCHEDULE_APPROVED },
            { label: "In Progress", value: RECOVERY_SCHEDULE_INPROGRESS },
        ]
    },
    {
        label: "Re-Baseline Schedule",
        key: "rebaseLineSchedule",
        permissions: [
            { label: "Access", value: REBASELINE_SCHEDULE_ACCESS },
            { label: "Create", value: REBASELINE_SCHEDULE_CREATE },
            { label: "Approved", value: REBASELINE_SCHEDULE_APPROVED },
            { label: "In Progress", value: REBASELINE_SCHEDULE_INPROGRESS },
        ]
    },
    {
        label: "Update Schedule",
        key: "updateSchedule",
        permissions: [
            { label: "Access", value: UPDATE_SCHEDULE_ACCESS },
            { label: "Create", value: UPDATE_SCHEDULE_CREATE },
            { label: "Approved", value: UPDATE_SCHEDULE_APPROVED },
            { label: "In Progress", value: UPDATE_SCHEDULE_INPROGRESS },
            { label: "Actual Update", value: UPDATE_SCHEDULE_ACTUALUPDATE },
        ]
    },
    {
        label: "Capex",
        key: "capexSchedule",
        isAlignment: true,
        permissions: [
            { label: "Access", value: CAPEX_ACCESS },
            { label: "Capex Menu Access", value: CAPEX_MENU_ACCESS },
            { label: "Committed Cost Access", value: COMMITTED_COST_ACCESS },
            // { label: "Create", value: CAPEX_CREATE },
        ]
    },
    {
        label: "View Schedule",
        key: "viewSchedule",
        isAlignment: true,
        permissions: [
            { label: "Access", value: VIEW_SCHEDULE_ACCESS },
            { label: "Activity Access", value: ACTIVITY_WISE_ACCESS },
            { label: "Resource Access", value: RESOURCE_WISE_ACCESS },
        ]
    },
    {
        label: "Milestone",
        key: "milestone",
        permissions: [
            { label: "Access", value: MILESTONE_ACCESS },
            { label: "Create", value: MILESTONE_CREATE },
            { label: "View", value: MILESTONE_VIEW },
            { label: "Edit", value: MILESTONE_EDIT },
            { label: "Delete", value: MILESTONE_DELETE },
            // { label: "Comment", value: MILESTONE_COMMENT },
        ]
    },
    {
        label: "DMS",
        key: "dmsManagement",
        isAlignment: true,
        permissions: [
            { label: "Access", value: DMS_ACCESS },
        ]
    },
    {
        label: "HSE Tracker",
        key: "hseTracker",
        permissions: [
            { label: "Access", value: HSE_ACCESS },
            { label: "Create", value: HSE_CREATE },
        ]
    },
    {
        label: "Incident Tracker",
        key: "incidentTracker",
        permissions: [
            { label: "Access", value: INCIDENT_ACCESS },
            { label: "Create", value: INCIDENT_CREATE },
            { label: "View", value: INCIDENT_VIEW },
            { label: "Edit", value: INCIDENT_EDIT },
        ]
    },
    {
        label: "EHS Finding Tracker",
        key: "EhsFindingTracker",
        permissions: [
            { label: "Access", value: EHS_FINDING_TRACKER_ACCESS },
            { label: "Create", value: EHS_FINDING_TRACKER_CREATE },
            { label: "View", value: EHS_FINDING_TRACKER_VIEW },
            { label: "Edit", value: EHS_FINDING_TRACKER_EDIT },
            { label: "Delete", value: EHS_FINDING_TRACKER_DELETE }
        ]
    },
    {
        label: "Legal Compliance Tracker",
        key: "legalComplianceTracker",
        permissions: [
            { label: "Access", value: LEGAL_TRACKER_ACCESS },
            { label: "Create", value: LEGAL_TRACKER_CREATE },
            { label: "View", value: LEGAL_TRACKER_VIEW },
            { label: "Edit", value: LEGAL_TRACKER_EDIT },
        ]
    },
    {
        label: "Cost",
        key: "costManagement",
        permissions: [
            { label: "Cost Tracker", value: COST_TRACKER_ACCESS },
            { label: "Cost Update", value: COST_UPDATE_ACCESS },
        ]
    },
    {
        label: "Workflows",
        key: "workflowsInitiate",
        permissions: [
            { label: "Workflows", value: INITIATE_WORKFLOW_ACCESS },
        ]
    },
    {
        label: "Leads",
        key: "leadsTracker",
        permissions: [
            { label: "Access", value: LEADS_TRACKER_ACCESS },
            { label: "Create", value: LEADS_TRACKER_CREATE },
            { label: "View", value: LEADS_TRACKER_VIEW },
            { label: "Edit", value: LEADS_TRACKER_EDIT },
            { label: "Delete", value: LEADS_TRACKER_DELETE },
        ]
    },
    {
        label: "Deals",
        key: "dealsTracker",
        permissions: [
            { label: "Access", value: DEALS_TRACKER_ACCESS },
            { label: "Create", value: DEALS_TRACKER_CREATE },
            { label: "View", value: DEALS_TRACKER_VIEW },
            { label: "Edit", value: DEALS_TRACKER_EDIT },
            { label: "Delete", value: DEALS_TRACKER_DELETE },
        ]
    },
    {
        label: "Config & Settings",
        key: "configSetting",
        isAlignment: true,
        permissions: [
            { label: "Workflow Access", value: WORKFLOW_ACCESS },
            { label: "Project Setting Access", value: PROJECT_SETTING },
            { label: "Master Data Access", value: MASTER_DATA_ACCESS },
        ]
    },
    {
        label: "Master Data Access",
        key: "masterDataAccess",
        isAlignment: true,
        permissions: [
            { label: "Action Tracker", value: ACTION_TRACKER_DATA_ACCESS },
            { label: "Compliance", value: COMPLIANCE_DATA_ACCESS },
            { label: "Design and Engineering", value: DESIGN_ENGINEERING_DATA_ACCESS },
            { label: "EHS Finding", value: EHS_FINDING_DATA_ACCESS },
            { label: "HSE", value: HSE_DATA_ACCESS },
            { label: "Leads", value: LEADS_DATA_ACCESS },
            { label: "Legal Compliance", value: LEGAL_COMPLIANCE_DATA_ACCESS },
            { label: "Operating Cost", value: OPERATING_COST_DATA_ACCESS },
            { label: "Procurement", value: PROCUREMENT_DATA_ACCESS },
            { label: "Risk", value: RISK_DATA_ACCESS },
            { label: "Statutory Approval", value: STATUTORY_APPROVAL_DATA_ACCESS },
            { label: "Workflow", value: WORKFLOW_DATA_ACCESS },
            { label: "Warehousing (Revenue&Leasing)", value: WAREHOUSING_DATA_ACCESS },
            { label: "Rail (Revenue&Leasing)", value: RAIL_DATA_ACCESS },
            { label: "Commercial (Revenue&Leasing)", value: COMMERCIAL_DATA_ACCESS },
            { label: "Insurance", value: INSURANCE_DATA_ACCESS },
        ]
    },
    // {
    //     label: "Physical Progress",
    //     key: "physicalProgress",
    //     permissions: [
    //         { label: "Access", value: PHYSICAL_PROGRESS_ACCESS },
    //         { label: "Create", value: PHYSICAL_PROGRESS_CREATE },
    //         { label: "View", value: PHYSICAL_PROGRESS_VIEW },
    //         { label: "Edit", value: PHYSICAL_PROGRESS_EDIT },
    //         { label: "Delete", value: PHYSICAL_PROGRESS_DELETE },
    //         { label: "Comment", value: PHYSICAL_PROGRESS_COMMENT },
    //     ]
    // },
    // {
    //     label: "Monthly Plan",
    //     key: "monthlyPlan",
    //     permissions: [
    //         { label: "Access", value: MONTHLY_PLAN_ACCESS },
    //         { label: "Create", value: MONTHLY_PLAN_CREATE },
    //         { label: "View", value: MONTHLY_PLAN_VIEW },
    //         { label: "Edit", value: MONTHLY_PLAN_EDIT },
    //         { label: "Delete", value: MONTHLY_PLAN_DELETE },
    //         { label: "Comment", value: MONTHLY_PLAN_COMMENT },
    //     ]
    // },
    // {
    //     label: "Milestone",
    //     key: "milestone",
    //     permissions: [
    //         { label: "Access", value: MILESTONE_ACCESS },
    //         { label: "Create", value: MILESTONE_CREATE },
    //         { label: "View", value: MILESTONE_VIEW },
    //         { label: "Edit", value: MILESTONE_EDIT },
    //         { label: "Delete", value: MILESTONE_DELETE },
    //         { label: "Comment", value: MILESTONE_COMMENT },
    //     ]
    // },
    // {
    //     label: "Material",
    //     key: "material",
    //     permissions: [
    //         { label: "Access", value: MATERIAL_ACCESS },
    //         { label: "Create", value: MATERIAL_CREATE },
    //         { label: "View", value: MATERIAL_VIEW },
    //         { label: "Edit", value: MATERIAL_EDIT },
    //         { label: "Delete", value: MATERIAL_DELETE },
    //         { label: "Comment", value: MATERIAL_COMMENT },
    //     ]
    // },
    // {
    //     label: "Manpower",
    //     key: "manpower",
    //     permissions: [
    //         { label: "Access", value: MANPOWER_ACCESS },
    //         { label: "Create", value: MANPOWER_CREATE },
    //         { label: "View", value: MANPOWER_VIEW },
    //         { label: "Edit", value: MANPOWER_EDIT },
    //         { label: "Delete", value: MANPOWER_DELETE },
    //         { label: "Comment", value: MANPOWER_COMMENT },
    //     ]
    // },
    // {
    //     label: "Machinery",
    //     key: "machinery",
    //     permissions: [
    //         { label: "Access", value: MACHINERY_ACCESS },
    //         { label: "Create", value: MACHINERY_CREATE },
    //         { label: "View", value: MACHINERY_VIEW },
    //         { label: "Edit", value: MACHINERY_EDIT },
    //         { label: "Delete", value: MACHINERY_DELETE },
    //         { label: "Comment", value: MACHINERY_COMMENT },
    //     ]
    // },
];


const PermissionList = () => {
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [selectedPermissions, setSelectedPermissions] = useState({});
    const [modules, setModules] = useState([]);

    const rolesData = useGetAllRolesQuery({ projectId })
    const [assignPermissionFun, assignPermissionRes] = useAssignPermissionMutation();
    const [checkPermissionFun, checkPermissionRes] = useLazyGetCheckRolePermissionQuery();

    const formikRef = useRef();

    const [formData, setFormData] = useState({
        projectId: projectId,
        roleId: '',
    })

    const validationSchema = Yup.object({
        roleId: Yup.string().required("Role field is required."),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        const countPermission = modules.reduce(
            (acc, mod) => acc + (mod.permissions?.length || 0),
            0
        );
        if (countPermission == 0) {
            openNotification('At least one permission is required.', 'error')
            return
        }

        const transformed = {
            ...values,
            projectId: projectId,
            modules: modules
        };

        assignPermissionFun(transformed);
    };

    useEffect(() => {
        if (assignPermissionRes?.isSuccess) {
            if (assignPermissionRes?.data?.status?.toLowerCase() == 'success') {
                formikRef.current?.resetForm();
                setModules([]);
                openNotification(assignPermissionRes?.data?.message, 'success')
            } else {
                openNotification(assignPermissionRes?.data?.message, 'error')
            }
        }
    }, [assignPermissionRes?.isSuccess]);

    useEffect(() => {
        if (assignPermissionRes?.isError) {
            if (assignPermissionRes?.error?.data?.status?.toLowerCase() == 'fail') {
                openNotification(assignPermissionRes?.error?.data?.message, 'error')
            } else {
                openNotification(assignPermissionRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
        }
    }, [assignPermissionRes?.isError]);

    useEffect(() => {

        if (checkPermissionRes?.status == "fulfilled") {
            // console.log(checkPermissionRes);

            const flatUserPermissions = checkPermissionRes?.data?.data?.modules?.flatMap(mod => mod.permissions);
            // console.log(flatUserPermissions);

            // Build selectedChildrenArray based on modules
            const selectedChildrenArray = permissionConfig?.map((child) => {
                const matchedPermissions = child?.permissions
                    .filter((perm) => flatUserPermissions?.includes(perm?.value))
                    .map((perm) => perm?.value);

                if (matchedPermissions?.length > 0) {
                    return {
                        moduleName: child?.key,
                        permissions: matchedPermissions
                    };
                }
                return null;
            }).filter(Boolean)
            // console.log(selectedChildrenArray);            
            setModules(selectedChildrenArray)
        }
    }, [checkPermissionRes]);

    const isPermissionChecked = (moduleKey, permissionValue) => {
        return modules.some(
            (m) =>
                m.moduleName === moduleKey &&
                m.permissions.includes(permissionValue)
        );
    };

    const handlePermissionToggle = (moduleKey, permissionValue) => {

        setModules((prevModules) => {
            const moduleIndex = prevModules.findIndex(
                (m) => m.moduleName === moduleKey
            );

            if (moduleIndex !== -1) {
                const module = prevModules[moduleIndex];
                const hasPermission = module.permissions.includes(permissionValue);

                const updatedPermissions = hasPermission
                    ? module.permissions.filter((p) => p !== permissionValue)
                    : [...module.permissions, permissionValue];

                // Remove module if no permissions left
                if (updatedPermissions.length === 0) {
                    return prevModules.filter((_, i) => i !== moduleIndex);
                }

                return prevModules.map((m, i) =>
                    i === moduleIndex
                        ? { ...m, permissions: updatedPermissions }
                        : m
                );
            }

            // Add new module
            return [
                ...prevModules,
                {
                    moduleName: moduleKey,
                    permissions: [permissionValue],
                },
            ];
        });

    };

    const checkRolePermission = (roleId) => {
        checkPermissionFun(roleId)
    }

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };


    return (
        <>
            <Grid container spacing={2} sx={{ mt: '20px', p: 2 }}>
                <Grid size={12}>
                    <Typography variant="h5" sx={{ mb: 1 }}>
                        Assign Permission
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Formik
                        innerRef={formikRef}
                        initialValues={formData}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>

                                    <Grid size={6}>
                                        <Autocomplete
                                            options={rolesData?.data?.data || []}
                                            getOptionLabel={(option) => option?.displayName}
                                            value={rolesData?.data?.data?.find((option) => option?.id === values?.roleId) || null}
                                            onChange={(_, newValue) => {
                                                setFieldValue("roleId", newValue ? newValue?.id : "")
                                                checkRolePermission(newValue?.id);
                                            }}
                                            onBlur={() => setTouched({ ...touched, roleId: true })}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Role"
                                                    placeholder='Select Role'
                                                    name="roleId"
                                                    slotProps={{ inputLabel: { shrink: true } }}
                                                    variant="filled"
                                                />
                                            )}
                                            ListboxProps={{
                                                sx: { fontSize: "13px" },
                                            }}
                                        />
                                        {touched?.roleId && errors?.roleId &&
                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.roleId}`}</FormHelperText>
                                        }

                                    </Grid>
                                    <Grid size={6}>
                                        <CustomButton
                                            label="Save"
                                            startIcon={<SaveIcon />}
                                            type='submit'
                                            loading={assignPermissionRes?.isLoading}
                                            sx={{
                                                backgroundColor: "#2563EB",
                                                fontFamily: 'Outfit',
                                                fontWeight: 500,
                                                fontSize: '14px',
                                                lineHeight: '100%',
                                                letterSpacing: '0px',
                                            }}
                                        />
                                        {/* <CustomButton
                                            type='submit'
                                            // loading={assignPermissionRes?.isLoading}
                                            variant="contained"
                                            sx={{
                                                // backgroundColor: `${theme?.customSettings?.themeColor}`,
                                                color: '#FFF',
                                                fontWeight: '500', textTransform: 'none',
                                                fontSize: '16px', float: 'right'
                                            }} /> */}
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Grid>
                <Grid size={12}>
                    <Card variant="outlined">
                        <CardContent>

                            {permissionConfig.map((section) => (
                                <Box key={section.key} mb={3}>
                                    {/* Section Header */}
                                    <Typography
                                        sx={{
                                            fontFamily: "Outfit",
                                            fontWeight: 600,
                                            fontSize: "16px",
                                            mb: 1,
                                        }}
                                    >
                                        {section.label}
                                    </Typography>

                                    <Divider sx={{ mb: 1 }} />

                                    {/* Permission Switches */}
                                    <Grid container spacing={2}>
                                        {section.permissions.map((perm) => (
                                            <Grid size={{ xs: 6, sm: 6, md: section?.isAlignment ? 2 : 1.5 }} key={perm.value}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        p: '5px',
                                                        border: "1px solid #E4E4E4",
                                                        borderRadius: "6px",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontFamily: "Outfit",
                                                            fontSize: "13px",
                                                            // fontWeight: 500,
                                                        }}
                                                    >
                                                        {perm.label}
                                                    </Typography>

                                                    <Switch
                                                        size="small"
                                                        checked={isPermissionChecked(
                                                            section.key,
                                                            perm.value
                                                        )}
                                                        onChange={() =>
                                                            handlePermissionToggle(
                                                                section.key,
                                                                perm.value
                                                            )
                                                        }
                                                        color="primary"
                                                    />
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            ))}
                        </CardContent>
                    </Card>
                </Grid>
                {/* <Grid size={12}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 2,
                            border: "1px solid #E5E7EB",
                            boxShadow: "none",
                        }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#FAFAFA" }}>
                                    <TableCell>
                                        <Typography fontWeight={600}>
                                            Menus
                                        </Typography>
                                    </TableCell>
                                    {channels.map((channel) => (
                                        <TableCell align="center" key={channel}>
                                            <Typography fontWeight={500}>
                                                {channel.charAt(0).toUpperCase() +
                                                    channel.slice(1)}
                                            </Typography>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow key={row.key}>
                                        <TableCell>
                                            <Typography fontWeight={500}>
                                                {row.label}
                                            </Typography>
                                        </TableCell>

                                        {channels.map((channel) => (
                                            <TableCell align="center" key={channel}>
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    gap={1}
                                                >
                                                    <Switch
                                                        size="small"
                                                        checked={
                                                            settings[row.key][channel]
                                                        }
                                                        onChange={handleToggle(
                                                            row.key,
                                                            channel
                                                        )}
                                                    />
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        {settings[row.key][channel]
                                                            ? "Yes"
                                                            : "No"}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid> */}
            </Grid>

        </>
    );
}

export default PermissionList;